import React from "react";
import { CONTENT_MAX_WIDTH, PAGE_PADDING, SECTION_GAP } from "./constants";

interface PageLayoutProps {
  children: React.ReactNode;
  /** Override max-width (default: CONTENT_MAX_WIDTH) */
  maxWidth?: number | string;
  /** Disable horizontal padding (e.g. when a table must fill edge-to-edge) */
  noPadding?: boolean;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, maxWidth = CONTENT_MAX_WIDTH, noPadding = false }) => {

  return (
    <div
      style={{
        width: "100%",
        maxWidth,
        padding: noPadding ? 0 : `0 ${PAGE_PADDING}px ${PAGE_PADDING}px`,
        display: "flex",
        flexDirection: "column",
        gap: SECTION_GAP,
        boxSizing: "border-box",
      }}
    >
      {children}
    </div>
  );
};

export default PageLayout;
